import React, { useState } from 'react'
import SiteButton from '../../Core/SiteButton'
import { styled } from 'linaria/react'
import QuantityButton from '../../Core/Buttons/QuantityButton'
// import WhishlistButton from '../../Core/Buttons/WishlistButton'
import { useIntl } from '@jetshop/intl'
import { theme } from '../../Theme'
import { getPackageStockStatus, isArrayWithItems } from '../../Core/Util/Helpers'
import { STOCK_ID } from '../../Core/Util/Constants'
import { useAddToCart } from '../../../hooks/useAddToCart'

const ProductAddToCartContainer = styled.div`
   /* ${theme.below.md} {
      .heart-animation-block {
         background-image: url('../../../svg/Heart.svg');
         background-repeat: no-repeat;
         background-size: 2900%;
         background-position: left;
         height: 38px;
         width: 38px;
         scale: 2.2;
         cursor: pointer;
      }
   } */

   .cart-button {
      width: 100%;
      max-width: 992px;
      padding: 0.75rem 0.75rem;
      ${theme.below.md} {
         font-size: 1rem;
      }
      ${theme.below.sm} {
         padding: 0.5rem 0.75rem;
         font-size: 0.8rem;
      }
   }
`


const ProductAddToCart = ({ selectedVariant, packageProducts, productInformation, ...props }) => {
   const { addProductToCart } = useAddToCart();
   const t = useIntl()
   const [quantity, setQuantity] = useState(1)

   const onlyForSaleInStore = productInformation?.onlyForSaleInStore;
   const isMainVariantPackage = selectedVariant?.isPackage === true
   const isPackageItems = isMainVariantPackage && isArrayWithItems(packageProducts)
   const packageStatusInfo =
      isPackageItems && selectedVariant?.stockStatus?.buyable === true
         ? getPackageStockStatus(packageProducts)
         : {stockStatusId: STOCK_ID.OUT_OF_STOCK, text: t('stock status out of stock') }

   const stockStatusId = isMainVariantPackage ? packageStatusInfo?.stockStatusId : selectedVariant?.stockStatus?.stockStatusId

   const buttonText = () => {
      if(onlyForSaleInStore){
         return t('only for sale in store')
      }
      if (STOCK_ID.IN_STOCK.includes(stockStatusId)) {
         return t('add to cart')
      } else if (STOCK_ID.PREBOOK.includes(stockStatusId)) {
         return t('book in advance')
      } else { // STOCK_ID.OUT_OF_STOCK
         return t('Out of stock')
      }
   }

   const buttonColor = () => {
      if(onlyForSaleInStore){
         return 'black'
      }
      if (STOCK_ID.IN_STOCK.includes(stockStatusId)) { 
         return 'green'
      } else if (STOCK_ID.PREBOOK.includes(stockStatusId)) { 
         return 'yellow'
      } else { // STOCK_ID.OUT_OF_STOCK
         return 'black'
      }
   }

   const isButtonDisabled = () => {
      return (
         (STOCK_ID.OUT_OF_STOCK.includes(stockStatusId))||
         !selectedVariant?.currentPrice ||
         selectedVariant?.stockStatus?.buyable === false ||
         onlyForSaleInStore
      )
   }

   const handleAddToCart = () => {
      addProductToCart(selectedVariant, selectedVariant?.articleNumber, quantity, isPackageItems);
   }

   return (
      <ProductAddToCartContainer
         className="d-flex align-items-center gap-2 add-to-cart-container"
         {...props}
      >
         <QuantityButton qty={quantity} updateQuantity={setQuantity} />
         <SiteButton
            className="px-32 cart-button"
            size="large"
            styleType="solid"
            uppercase
            disabled={isButtonDisabled()}
            color={buttonColor()}
            onClick={handleAddToCart}
         >
            {buttonText()}
         </SiteButton>
      </ProductAddToCartContainer>
   )
}

export default ProductAddToCart